"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomStrId = exports.randomNumId = exports.isObject = void 0;
const isObject = (value) => {
    if (typeof value === 'string')
        return false;
    if (typeof value === 'number')
        return false;
    if (typeof value === 'boolean')
        return false;
    if (typeof value === 'undefined')
        return false;
    if (typeof value === 'bigint')
        return false;
    if (typeof value === 'symbol')
        return true;
    if (typeof value === 'function')
        return true;
    if (typeof value === 'object') {
        if (value === null)
            return false;
        return true;
    }
    throw new Error(`Unknown type: ${value} ${typeof value}`);
};
exports.isObject = isObject;
const randomNumId = () => Math.random() * Math.pow(10, 10);
exports.randomNumId = randomNumId;
const randomStrId = () => `${(0, exports.randomNumId)()}`;
exports.randomStrId = randomStrId;
